import React from "react";
import { useState, useEffect , useContext } from 'react';
import TableComponent from '../../../../components/table';
import { Spin } from 'antd';
import PaginationComponent from '../../../../components/pagination';
import Api from "../../../../services/api";
import {getColor,getDates} from '../../../../utility';
import { toast } from 'react-toastify';

const AppPerformance = (props) => {
  const [appAdsetPerformance,setAppAdsetPerformance] = useState([]);
  const [page,setPage] = useState(1);
  const [sort,setSort] = useState({});
  const [loading,setLoading] = useState(true);
  const [filterName, setFilterName] = useState('');

  const [activeFilterKey, setActiveFilterKey] = useState(null);

	useEffect(() => {
    setLoading(true)
    Api.get(`api/overview/app_performance?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&sort_value_by=${props.sortValue}&sort_by_column=${sort.column || ''}&sort_by_column_value=${sort.value || ''}&name=${filterName}&page=${page}`)
    .then(result => {
      if(result?.data?.code == 0)
        setAppAdsetPerformance(result.data)
      setLoading(false)
    });
  }, [props.filter, props.reload ,props.sortValue,page,sort, filterName]);

  const handleChangePage = (page) => {
    setPage(page);
  }

  const handleFilterName = (value, key) => {
    if (key === 'name') {
      setFilterName(value); // cập nhật để useEffect gọi lại API
      setPage(1); // reset về page đầu
    }
  };

  const handleSort = (key) => {
    const arr = key.split('-')
    setSort({
      column : arr[0],
      value : arr[1]
    })
  }

  const handleFilter = (e, key) => {
    console.log(e,key)
  }

  useEffect(() => {
    const handleClickOutside = () => {
      setActiveFilterKey(null);
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <Spin spinning={loading}>
    <TableComponent 
      sort="1"
      filter={true}
      column={[{
        key: 'name',
        name: 'Name',
        customRender: (value, item) => {
          const displayValue = value?.value || value?.format || value;
          
          return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
          {item?.thumb && (
              <div style={{ position: 'relative', width: 30, height: 30, marginRight: 8 }}>
                {/*<img*/}
                {/*    width="30px"*/}
                {/*    height="30px"*/}
                {/*    src={item?.thumb}*/}
                {/*    alt={item?.thumb}*/}
                {/*    style={{ marginRight: '8px', borderRadius: "8px" }}*/}
                {/*/>*/}
                <img
                    src={item?.thumb}
                    alt={item?.thumb}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: "8px"
                    }}
                />
                <img
                    src={`/bg-${item?.os?.value}.png`}
                    alt=""
                    className="app-logo"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      pointerEvents: 'none',
                    }}
                />
              </div>
          )}
          <span style={{ overflow : "hidden" , textOverflow: "ellipsis" , whiteSpace: "nowrap"}}>{displayValue}</span>
          </div>
          );
        }
      },{
        key: 'cost',
        name: 'Cost ($)',
      },{
        key: 'install',
        name: 'Installs',
      },{
        key: 'rev_iaa',
        name: 'Ad Revenue',
      },{
        key: 'rev_iap',
        name: 'IAP Revenue',
      }]}
      handleFilterName={handleFilterName}
      data={appAdsetPerformance.data || []}
      handleFilter={handleFilter}
      sort={handleSort}
      tableKey="app_performance_table"
      activeFilterKey={activeFilterKey}
      setActiveFilterKey={setActiveFilterKey}
    />
    <PaginationComponent 
      current={appAdsetPerformance.page}
      total={appAdsetPerformance.total_page}
      handleChangePage={handleChangePage} />
    </Spin>
  )
}
export default AppPerformance;